$(document).ready(function () {
  	jQuery.get("https://pro.ip-api.com/json/?key=MQXSLbxUAhwAwzB", function(response) {
      console.log(response.countryCode);
      if(response.countryCode != 'AU')
        $('#AddToCartForm').addClass('out-au');
      else
        $('#AddToCartForm').removeClass('out-au');
    }, "jsonp");
});